import * as constants from '../constants';

export const surveyWaveCreateSuccess = (data) => ({type: constants.SURVEY_WAVE_CREATE_SUCCESS, payload: {data}});
export const surveyWaveEditSuccess = (data) => ({type: constants.SURVEY_WAVE_EDIT_SUCCESS, payload: {data}});
export const surveyWaveDeleteSuccess = (data) => ({type: constants.SURVEY_WAVE_DELETE_SUCCESS, payload: {data}});
